import React from 'react';
import { Spin } from 'antd';
import { Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { clearCommercialControl, fetchCommercialUsage, selectCommercialUsageIdentityKey } from './Actions/commercialControl.action';
import { canAccessHeaderItem, headerItems } from './Scenes/common/mainLayout';

const WithRoleProtection = ({ path, children }) => {
    const dispatch = useDispatch();
    const user = useSelector(state => state.users.user);
    const commercialControl = useSelector(state => state.commercialControl || {});
    const commercialUsageIdentityKey = useSelector(selectCommercialUsageIdentityKey);
    const matched = headerItems.find(item => path.startsWith(item.link));
    const requiresCommercialUsage = matched?.requiresWorkspaceUserManagement ||
        matched?.requiresRepository ||
        matched?.requiresCriteriaManagement;

    React.useEffect(() => {
        if (!requiresCommercialUsage) return;
        if (!user?.id) return;
        if (
            commercialControl.usageIdentityKey &&
            commercialControl.usageIdentityKey !== commercialUsageIdentityKey
        ) {
            dispatch(clearCommercialControl());
            return;
        }
        if (
            commercialControl.usageSnapshot &&
            commercialControl.usageIdentityKey === commercialUsageIdentityKey
        ) {
            return;
        }
        if (
            commercialControl.isLoadingUsage &&
            commercialControl.loadingUsageIdentityKey === commercialUsageIdentityKey
        ) {
            return;
        }
        if (commercialControl.lastCommercialError) return;
        dispatch(fetchCommercialUsage()).catch(() => {});
    }, [
        commercialControl.isLoadingUsage,
        commercialControl.lastCommercialError,
        commercialControl.loadingUsageIdentityKey,
        commercialControl.usageIdentityKey,
        commercialControl.usageSnapshot,
        commercialUsageIdentityKey,
        dispatch,
        requiresCommercialUsage,
        user?.id,
    ]);

    const hasCurrentCommercialUsage =
        Boolean(commercialControl.usageSnapshot) &&
        commercialControl.usageIdentityKey === commercialUsageIdentityKey;
    const isLoadingCurrentCommercialUsage =
        commercialControl.isLoadingUsage &&
        commercialControl.loadingUsageIdentityKey === commercialUsageIdentityKey;
    const commercialControlForAccess = hasCurrentCommercialUsage ? commercialControl : {
        ...commercialControl,
        usageSnapshot: null,
        capabilities: {},
        plan: null,
    };

    if (
        requiresCommercialUsage &&
        user?.id &&
        !hasCurrentCommercialUsage &&
        (isLoadingCurrentCommercialUsage || !commercialControl.lastCommercialError)
    ) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <Spin size="large" />
            </div>
        );
    }

    if (!matched || !canAccessHeaderItem(matched, user, commercialControlForAccess)) {
        return <Navigate to="/404" replace />;
    }

    return children;
};

export default WithRoleProtection;
